import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { cx } from '@emotion/css'
import getCountryISO3 from 'country-iso-2-to-3'
import camelCase from 'lodash/camelCase'
import startCase from 'lodash/startCase'
import { bool, oneOf, string } from 'prop-types'
import { IconFlagComponent } from '../../utils/icon-flags'
import Empty from '../icon/empty'

// Creates Unicode flag from a two-letter ISO country code.
export const getUnicodeFlagIcon = (country = '') => {
	const codePoints = country.toUpperCase().replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))

	return codePoints
}

const FlagByCountryCode = ({ className, countryCode, fallbackImage = 'empty', unicodeFlag = false, ...props }) => {
	const { flagsShape } = useConfig()

	const componentName = `${startCase(camelCase(getCountryISO3(countryCode)?.toLocaleLowerCase())).replace(/ /g, '')}${
		flagsShape === 'square' ? 'Square' : ''
	}Icon`

	const UnicodeFlag = () => <span className={cx(className, 'unicode')}>{getUnicodeFlagIcon(countryCode)}</span>

	const FallbackComponent = fallbackImage === 'empty' ? Empty : fallbackImage === 'unicode' ? UnicodeFlag : null

	const Icon = unicodeFlag ? UnicodeFlag : IconFlagComponent(componentName) ?? FallbackComponent

	return Icon ? (
		<Icon className={cx(className, !IconFlagComponent(componentName) && fallbackImage)} fontSize="button" {...props} />
	) : null
}

FlagByCountryCode.propTypes = {
	className: string,
	countryCode: string,
	fallbackImage: oneOf(['empty', 'none', 'unicode']),
	unicodeFlag: bool,
}

export default FlagByCountryCode
